import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { URL } from '../../constants/url'
import { RootState } from '../../../states/containers/store'
import { setPath } from '../../../utils/url'
import { postFreeeLink } from '../../../states/apis/link'
import LoadingSquare from '../../components/common/LoadingSquare'

const FreeeCallback: FC = () => {
  const history = useHistory()

  const {
    commonPart,
    login,
  } = useSelector((state: RootState) => (state))

  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }

  const code = useQuery().get('code')

  const [error, setError] = useState<string>("")

  useEffect(() => {
    if (!login.accessToken) return
    if (code) {
      postFreeeLink(code).then(() => {
        history.push({ pathname: setPath(URL.SETTING_RECODE_API_CONNECT.path, commonPart.language as string), state: 'freee_success' })
      }).catch((e) => {
        if (e.status === 401) {
          setError("権限が不足しています。Freee勤怠の管理者権限を持つユーザーが実行してください。")
        } else {
          setError("不明なエラーが発生しました。管理者までお知らせください。")
        }
      })
    } else {
      history.push({ pathname: setPath(URL.SETTING_RECODE_API_CONNECT.path, commonPart.language as string), state: 'freee_error' })
    }
  }, [login.accessToken])

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 130px)",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {
        error ? (
          <>
            <div
              style={{
                fontSize: "30px",
                fontWeight: "bold",
                color: "#4472ba",
                marginBottom: "24px",
              }}
            >
              freee連携に失敗しました
            </div>
            <div
              style={{
                fontSize: "18px",
                marginBottom: "24px",
                color: "#666666",
              }}
            >
              {error}
            </div>
            <div>
              <button
                type="button"
                onClick={() => history.push({ pathname: setPath(URL.SETTING_RECODE_API_CONNECT.path, commonPart.language as string) })}
                style={{
                  border: "solid 1px #999999",
                  borderRadius: "4px",
                }}
              >
                打刻データ連携の設定にもどる
              </button>
            </div>
          </>
        ) : (
          <>
            <LoadingSquare>
              <>
                Freee連携を設定しています…
              </>
            </LoadingSquare>
          </>
        )
      }
    </div>
  )
}

export default FreeeCallback
